import { setLinks } from '../../../../renderer/setters';

var getAmpUrl = function getAmpUrl(url) {
  if (url === void 0) {
    url = '';
  }

  return url + (url.includes('?') ? '&' : '?') + '_amp_';
};

export var handleOldBlog = function handleOldBlog(tags, siteLevelData) {
  if (siteLevelData === void 0) {
    siteLevelData = {};
  }

  var _siteLevelData = siteLevelData,
      _siteLevelData$hasBlo = _siteLevelData.hasBlogAmp,
      hasBlogAmp = _siteLevelData$hasBlo === void 0 ? false : _siteLevelData$hasBlo,
      _siteLevelData$contex = _siteLevelData.context;
  _siteLevelData$contex = _siteLevelData$contex === void 0 ? {} : _siteLevelData$contex;
  var _siteLevelData$contex2 = _siteLevelData$contex.defaultUrl,
      defaultUrl = _siteLevelData$contex2 === void 0 ? '' : _siteLevelData$contex2;

  if (hasBlogAmp && defaultUrl.includes('/single-post/')) {
    return setLinks(tags, [{
      rel: 'amphtml',
      href: getAmpUrl(defaultUrl)
    }]);
  }

  return tags;
};